import {
  ForwardedRef,
  forwardRef,
  ForwardRefExoticComponent,
  ReactElement,
  RefAttributes,
} from 'react'
import Styles from './Container.module.scss'
import { usePropBasedStyles } from 'utility/styles'

type ContainerProps = {
  children: ReactElement | (ReactElement | null)[]
  className?: string
  id?: string
  size?: 800
  stretch?: boolean
  center?: boolean
  textCenter?: boolean
}

function Container(
  { children, className = '', id, ...otherProps }: ContainerProps,
  ref: ForwardedRef<HTMLDivElement>
) {
  const flagBasedClasses = usePropBasedStyles(Styles)(otherProps)
  const { stretch: _, center: __, textCenter: ___, ...toSpread } = otherProps
  return (
    <div
      ref={ref}
      className={`${Styles.root} ${className} ${
        otherProps.size && Styles[`size_${otherProps.size}`]
      } ${flagBasedClasses}`}
      id={id}
      {...toSpread}>
      {children}
    </div>
  )
}

/**
 * This limits the width of the page content to include a limited visualization
 **/
export default forwardRef(Container) as ForwardRefExoticComponent<
  ContainerProps & RefAttributes<HTMLDivElement>
>
